const fixedHeader = {
	el: {
		win: $(window),
		body: $('body'),
		header: $('.header'),
		main: $('.wrapper')
	},
	events() {
		const
			headerWrap = this.el.header,
			scrollTopZero = this.el.win.scrollTop()

		// function that trigger when scroll the page
		this.el.win.on('scroll', e => {
			const currentScrollTop = $(e.currentTarget).scrollTop()

			// Condition for check if is Scroll Down or Scroll Up
			if (currentScrollTop > scrollTopZero) {
				// downscroll condition
				if (currentScrollTop > headerWrap.outerHeight()) {
					headerWrap.addClass('fixed')
					this.el.main.css('padding-top', headerWrap.outerHeight())
				}

			} else {
				// upscroll condition
				if (currentScrollTop < headerWrap.outerHeight()) {
					headerWrap.removeClass('fixed')
					this.el.main.removeAttr('style')
				}
			}
		})

		// Check if the current page has the class below, if yes, the function works. Avoid js erros
		if (!this.el.header.length) return
	},
	init() {
		this.events();
	}
}

fixedHeader.init();